// admin/src/lib/tracks.ts
//
// Default track_* flags for a given `kind`, mirroring the UPDATE this
// repo's migrations run whenever `kind` is set (0013_builder.sql, and the
// distance_time rows seeded in 0015_wave4.sql/0019_swim_drills.sql). The
// exercise edit page runs this when `kind` changes, then still lets the
// admin flip individual track_* switches (spec §3 Lane D).
import type { ExerciseKind } from './vocab';

export type Tracks = {
  track_reps: boolean;
  track_weight: boolean;
  track_time: boolean;
  track_distance: boolean;
  track_rir: boolean;
};

export function defaultTracksForKind(kind: ExerciseKind): Tracks {
  switch (kind) {
    case 'weight_reps':
      return { track_reps: true, track_weight: true, track_time: false, track_distance: false, track_rir: true };
    case 'bodyweight_reps':
      return { track_reps: true, track_weight: false, track_time: false, track_distance: false, track_rir: true };
    case 'hold':
      return { track_reps: false, track_weight: false, track_time: true, track_distance: false, track_rir: false };
    case 'distance_time':
      return { track_reps: false, track_weight: false, track_time: true, track_distance: true, track_rir: false };
  }
}
